/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import ScrollSequence from './Classes/Scrollsequence';

import Helper from './Classes/Helper';

import Accordion from './Classes/Accordion';
import Header from './Classes/Header';
import CV from './Classes/CV';
import Sticky from '../../node_modules/sticky-js';
import BackToTop from './Classes/BackToTop';
import Swiper from './lib/swiper';
import Gri from "./Classes/Gri";
import Home from "./Classes/Home";
import HashHandler from "./Classes/HashHandler"
import LinkHandler from "./Classes/LinkHandler"
import Video from "./Classes/Video"
import CookiesExtended from "./Classes/CookiesExtended"
import ImagesiteScroll from "./Classes/ImagesiteScroll"
import FocusHandler from "./Classes/FocusHandler"
import Adminbar from './Classes/Adminbar'
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

var headerInstance = null;
var accordionInstance = null;
var cvInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var stickyInstance = null;
var bttInstance = null;
var HashHandlerInstance = null
var LinkHandlerInstance = null
var highlightsInstance = null
var keyfigureInstance = null
var imagesiteScrollInstance = null
var cookieInstance = null
var homeInstance = null
var videoInstance = null
var gri = null;
var focusInstance = null;
var scrollSequenceInstance = null;

export default {
  version: () => {
    return NSContext.theme.version;
  },
};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  headerInstance = new Header();

  // new ResponsiveTablesLight({
  //   tableComponentSelector: '.ns-table-wrap',
  //   tableContainerSelector: '.ns-table-wrap > div',
  //   tableSelector: '.ns-table-wrap table'
  // });

  const llbSequenceImages = [];
  for (let i = 0; i <= 101; i++) {
    llbSequenceImages.push(`output_${`00${i}`.slice(-3)}.png`);
  }

  scrollSequenceInstance = new ScrollSequence({
    container: '.imagesite-container',
    scrollWith: '.imagesite-container',
    images: llbSequenceImages,
    imagesRoot: window.location.origin + '/2024/ar/app/themes/llb-ar-theme/dist/images/frames/',
    priorityFrames: [0, 1],
    cover: true,
    playUntil: 'out',
    starts: 'in'
  });

  focusInstance = new FocusHandler();

  if (Helper.isDesktop()) {
    Adminbar.changeMarginTop();
    stickyInstance = new Sticky('.header__bottom');
  }

  videoInstance = new Video();
  bttInstance = new BackToTop();

  HashHandlerInstance = new HashHandler();
  LinkHandlerInstance = new LinkHandler();


  accordionInstance = new Accordion({
    accordions: '.js-accordion-toggle'
  });

  cookieInstance = new CookiesExtended();

  cvInstance = new CV({
    cv: '.cv-item__title'
  });

  keyfigureInstance = new Swiper('.ns-keyfigure-slider', {
    // Default parameters
    touchEventsTarget: 'container',
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.keyfigure-swiper-button-next',
      prevEl: '.keyfigure-swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      // when window width is >= 320px
      768: {
        spaceBetween: 0,
        slidesPerView: 1,
      }
    }
  });
  homeInstance = new Home(keyfigureInstance);


  highlightsInstance = new Swiper('.ns-highlights', {
    // Default parameters
    touchEventsTarget: 'container',
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><svg width="13" height="18" xmlns="http://www.w3.org/2000/svg"><path stroke="#67924D" fill="#FFF" d="M6.443 16.5l4.947-7.714-5.016-7.594-5.017 7.594z" fill-rule="evenodd"/></svg></span>';
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      // when window width is >= 320px
      768: {
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
      }
    }
  });

  gri = new Gri();

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

});
